import LoginPage from '@/pages/login/LoginPage';
import MainLayout from '@/layouts/main';
import DashboardPage from '@/pages/dashboard/DashboardPage';

import GiftBoxCampaignsPage from '@/pages/gift-box-campaigns/GiftBoxCampaignsPage';
import GiftBoxCampaignsIndex from '@/pages/gift-box-campaigns/GiftBoxCampaignsIndex';
import GiftBoxCampaignsDetail from '@/pages/gift-box-campaigns/GiftBoxCampaignsDetail';
import GiftBoxCampaignsAnalyticsPage from '@/pages/gift-box-campaigns/GiftBoxCampaignsAnalyticsPage';
import GiftBoxCampaignsFeedbackPage from '@/pages/gift-box-campaigns/GiftBoxCampaignsFeedbackPage';
import ActionPages from '@/pages/action-pages/ActionPages';

import ProductsPage from '@/pages/corporate-products/ProductsPage';
import ProductsIndex from '@/pages/corporate-products/ProductsIndex';
import ProductsDetail from '@/pages/corporate-products/ProductsDetail';
import ProductRequestsIndex from '@/pages/corporate-products/ProductRequestsIndex';
import ProductRequestsDetail from '@/pages/corporate-products/ProductRequestsDetail';

import MarketplacePage from '@/pages/marketplace/MarketplacePage';
import MarketplacePhysicalGiftsIndex from '@/pages/marketplace/MarketplacePhysicalGiftsIndex';
import MarketplaceDigitalGiftsIndex from '@/pages/marketplace/MarketplaceDigitalGiftsIndex';
import MarketplaceOrdersIndex from '@/pages/marketplace/MarketplaceOrdersIndex';

import SurveysIndex from '@/pages/surveys/index';
import SurveysList from '@/pages/surveys/SurveysList';
import SurveyDetails from '@/pages/surveys/SurveyDetails';
import TemplatesList from '@/pages/surveys/TemplatesList';
import TemplateDetails from '@/pages/surveys/TemplateDetails';
import SurveyDetailsSummary from '@/pages/surveys/SurveyDetailsSummary';
import SurveyDetailsResults from '@/pages/surveys/SurveyDetailsResults';
import SurveyDetailsQuestions from '@/pages/surveys/SurveyDetailsQuestions';
import SurveyDetailsResponses from '@/pages/surveys/SurveyDetailsResponses';
import SurveyResponseForm from '@/pages/surveys/SurveyResponseForm';
import SurveyThemesList from "@/pages/surveys/SurveyThemesList";
import SurveyThemeDetails from "@/pages/surveys/SurveyThemeDetails";
import SurveyThemesGalleryList from "@/pages/surveys/SurveyThemesGalleryList";

import FulfilmentPage from '@/pages/fulfilment/FulfilmentPage';
import FulfilmentIndex from '@/pages/fulfilment/FulfilmentIndex';
import FulfilmentInventory from '@/pages/fulfilment/FulfilmentInventory';

import BillingPage from '@/pages/billing/BillingPage';
import BillingPaymentsPage from '@/pages/billing/BillingPaymentsPage';
import BillingTransactionHistory from '@/pages/billing/BillingTransactionHistory';
import BillingTransactionHistoryDirect from '@/pages/billing/BillingTransactionHistoryDirect';
import PaymentDocumentsIndex from '@/pages/billing/PaymentDocumentsIndex';

import ResourcesPage from '@/pages/resources/ResourcesPage';
import ResourcesIndex from '@/pages/resources/ResourcesIndex';
import ResourcesDetail from '@/pages/resources/ResourcesDetail';

import SettingsPage from '@/pages/settings/SettingsPage';
import SettingsUser from '@/pages/settings/SettingsUser';
import SettingsTeam from '@/pages/settings/SettingsTeam';
import SettingsTeamMembers from '@/pages/settings/SettingsTeamMembers';
import SettingsIntegrations from '@/pages/settings/SettingsIntegrations';

import OrdersPage from '@/pages/orders/OrdersPage';
import OrdersJobIndex from '@/pages/orders/JobIndex';
import OrdersJobDetail from '@/pages/orders/JobDetail';

const wsSuite = {
    path: '/',
    component: MainLayout,
    children: [
        {path: '/', redirect: 'dashboard'},
        {
            path: '/orders',
            component: OrdersPage,
            children: [
                {path: '/', component: OrdersJobIndex, name: 'orders-jobs'},
                {
                    path: 'enquiries',
                    component: OrdersJobIndex,
                    name: 'orders-jobs-enquiries',
                    meta: { type: 'enquiries' }
                },
                {
                    path: ':id/', component: OrdersPage,
                    children: [
                        {path: '/', component: OrdersJobDetail, name: 'orders-job-detail'},
                        {path: '*', redirect: '/orders'}
                    ]
                },
                {path: '*', redirect: '/orders'},
            ],
        },
        {path: '/dashboard', component: DashboardPage, meta: {title: 'Dashboard'}},
        {
            path: '/campaigns',
            component: GiftBoxCampaignsPage,
            meta: {
                pageClass: 'campaigns',
            },
            children: [
                {path: '/', component: GiftBoxCampaignsIndex},
                {path: 'action-pages', component: ActionPages, name: 'action-pages'},
                {
                    path: 'corporate-products',
                    component: ProductsPage,
                    children: [
                        {path: '/', component: ProductsIndex, name: 'corporate-products'},
                        {
                            path: 'requests',
                            component: ProductsPage,
                            children: [
                                {path: '/', component: ProductRequestsIndex, name: 'product-requests-index'},
                                {path: ':id', component: ProductRequestsDetail, name: 'product-requests-detail'},
                                {path: '*', redirect: '/campaigns/corporate-products/requests'},
                            ],
                        },
                        {path: ':id', component: ProductsDetail, name: 'products-detail'},
                        {path: '*', redirect: '/campaigns/corporate-products'},
                    ],
                },
                {
                    path: ':id',
                    component: GiftBoxCampaignsPage,
                    children: [
                        {path: '/', component: GiftBoxCampaignsDetail, name: 'campaign-detail'},
                        {path: 'analytics', component: GiftBoxCampaignsAnalyticsPage, name: 'campaign-analytics'},
                        {path: 'feedback', component: GiftBoxCampaignsFeedbackPage, name: 'campaign-feedback'},
                        {path: '*', redirect: '/'},
                    ],
                },
            ],
        },
        {
            path: '/marketplace',
            component: MarketplacePage,
            children: [
                {path: '/', component: MarketplacePhysicalGiftsIndex, name: 'marketplace-gifts-physical'},
                {
                    path: 'digital',
                    component: MarketplaceDigitalGiftsIndex,
                    name: 'marketplace-gifts-digital',
                    meta: {
                        title: 'Marketplace eGifts Selection',
                    },
                },
                {path: 'orders', component: MarketplaceOrdersIndex, name: 'marketplace-orders-index'},
                {path: '*', redirect: '/marketplace'},
            ],
        },
        {
            path: '/surveys',
            component: SurveysIndex,
            children: [
                {path: '/', component: SurveysList, name: 'surveys-index'},
                {path: 'templates', component: TemplatesList, name: 'surveys-templates'},
                {path: 'templates/:template_id', component: TemplateDetails, name: 'surveys-template-details'},
                {path: 'templates/:template_id/preview', component: TemplateDetails, name: 'surveys-template-preview', meta: {preview: true}},
                {path: 'themes', component: SurveyThemesList, name: 'surveys-themes'},
                {path: 'themes/gallery', component: SurveyThemesGalleryList, name: 'surveys-themes-gallery'},
                {path: 'themes/:theme_id', component: SurveyThemeDetails, name: 'surveys-theme-details'},
                {path: 'themes/gallery/:theme_id', component: SurveyThemeDetails, name: 'surveys-themes-gallery-details'},
                {
                    path: ':survey_id/', component: SurveyDetails,
                    children: [
                        {path: '/', component: SurveyDetailsSummary, name: 'surveys-details'},
                        {path: 'new', component: SurveyDetailsSummary, name: 'surveys-details-new', meta: {fromTemplate: true}},
                        {path: 'results', component: SurveyDetailsResults, name: 'surveys-details-results'},
                        {path: 'questions', component: SurveyDetailsQuestions, name: 'surveys-details-questions'},
                        {path: 'responses', component: SurveyDetailsResponses, name: 'surveys-details-responses'},
                        {path: 'responses/?question=:question&answer=:answer', component: SurveyDetailsResponses, name: 'surveys-details-responses-filtered'},
                        {path: 'responses/:response', component: SurveyDetailsResponses, name: 'surveys-details-single-response'},
                        {path: '*', redirect: '/'}
                    ]
                },
                {path: '*', redirect: '/surveys'},
            ],
        },
        {
            path: '/fulfilment',
            component: FulfilmentPage,
            children: [
                {path: '/', component: FulfilmentIndex, name: 'fulfilment-orders'},
                {path: 'inventory', component: FulfilmentInventory, name: 'fulfilment-inventory'},
                {path: '*', redirect: '/fulfilment'},
            ],
        },
        {
            path: '/billing',
            component: BillingPage,
            children: [
                {path: '/', component: BillingPaymentsPage, name: 'billing-payments-page'},
                {
                    path: 'transaction-history-direct',
                    component: BillingTransactionHistoryDirect,
                    name: 'billing-transaction-history-direct',
                },
                {path: 'transaction-history', component: BillingTransactionHistory, name: 'billing-transaction-history'},
                {path: 'payment-documents', component: PaymentDocumentsIndex, name: 'payment-documents-index'},
                {path: '*', redirect: '/billing'},
            ],
        },
        {
            path: '/resources',
            component: ResourcesPage,
            children: [
                {path: '/', component: ResourcesIndex, name: 'resources-index'},
                {path: ':slug', component: ResourcesDetail, name: 'resources-detail'},
                {path: '*', redirect: '/resources'},
            ],
        },
        {
            path: '/settings',
            component: SettingsPage,
            children: [
                {path: '/', component: SettingsUser, name: 'settings-user'},
                {path: 'team', component: SettingsTeam, name: 'settings-team'},
                {path: 'team-members', component: SettingsTeamMembers, name: 'settings-team-members'},
                {path: 'integrations', component: SettingsIntegrations, name: 'settings-integrations'},
                {path: '*', redirect: '/settings'},
            ],
        },
    ],
};


const publicPages = [
    {path: '/login', component: LoginPage},
    {path: '/survey/:team/:slug', component: SurveyResponseForm, name: 'survey-form', meta: {public: true}},
    {path: '/survey/:team/:slug/:source', component: SurveyResponseForm, name: 'survey-source-form', meta: {public: true}},
]
export default [
    wsSuite,
    ...publicPages,
    {path: '*', redirect: '/dashboard'},
];
